const dependentVehicleFieldIds = Object.freeze({
    make: Object.freeze(['family', 'variant']),
    family: Object.freeze(['variant']),
    variant: Object.freeze([])
});

const getDependentVehicleFieldIds = (fieldId) => (
    Object.prototype.hasOwnProperty.call(dependentVehicleFieldIds, fieldId)
        ? dependentVehicleFieldIds[fieldId]
        : []
);

module.exports = {getDependentVehicleFieldIds};
